const featuresSettings = {
  disabled: 0,
  enabled: 1,
};

export default featuresSettings;
